export const CustomerBookingsQueryKey = 'customer-bookings';
export const UnbookedOrdersQueryKey = 'customer-unbooked-orders';
